/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ZusatzfeldDefinitionAuswahlmoeglichkeit from "./ZusatzfeldDefinitionAuswahlmoeglichkeit";
import ZusatzfeldType from "./ZusatzfeldType";

export default interface ZusatzfeldDefinition {
    type: ZusatzfeldType;
    zusatzfeldDefinitionId: string;
    name: string;
    bezeichnung: string;
    geaendert: string;
    auswahlmoeglichkeiten?: ZusatzfeldDefinitionAuswahlmoeglichkeit[];
    istIntern: boolean;
}

export enum ZusatzfeldDefinitionUrsprung {
    Seminar = "Seminar",
    Adresse = "Adresse",
    Teilnahme = "Teilnahme",
    Ressourcenkategorie = "Ressourcenkategorie",
    Seminarreihe = "Seminarreihe",
    Dozierend = "Dozierend"
}